import type { OnInit } from '@angular/core';
import { Component, input, ViewEncapsulation } from '@angular/core';
import { NgStyle } from '@angular/common';
import { UntilDestroy } from '@ngneat/until-destroy';

import { AbsenceCostCalculatorComponent } from '@helsana/absence-cost-calculator';

import type { AbsenceCostCalculatorProps } from './absence-cost.types';

@UntilDestroy()
@Component({
  selector: 'absence-cost-component',
  templateUrl: './absence-cost.component.html',
  styleUrls: ['./absence-cost.component.scss'],
  imports: [AbsenceCostCalculatorComponent, NgStyle],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class AbsenceCostComponent implements OnInit {
  public sectors: { label: string; value: string }[] = [];

  public props = input.required<AbsenceCostCalculatorProps>();

  protected static HEADER_HEIGHT = 73;

  ngOnInit(): void {
    this.sectors = this.props().branches.map((branch) => ({
      value: branch.absenceRate.toString(),
      label: branch.name
    }));
  }

  getHeaderPixel() {
    return AbsenceCostComponent.HEADER_HEIGHT + 'px';
  }

  onSubmitForm(target: HTMLElement) {
    target.scrollIntoView({ behavior: 'smooth' });
  }
}
